import { AST } from '@handlebars/parser';

import { concatenate } from 'utils/stringHelpers';

import {
  isBlockStatement,
  isCommentStatement,
  isContentStatement,
  isMustacheStatement,
  isPartialBlockStatement,
  isPartialStatement,
} from '../utils';
import { BlockStatementSerializer } from './block';
import { PartialBlockStatementSerializer } from './partialBlock';
import { PartialStatementSerializer } from './partial';
import { MustacheStatementSerializer } from './mustache';
import { CommentStatementSerializer } from './comment';
import { ContentStatementSerializer } from './content';

export class StatementSerializer {
  static serialize = (statement: AST.Statement) => {
    if (isBlockStatement(statement))
      return BlockStatementSerializer.serialize(statement, StatementSerializer.serializeAll);
    if (isCommentStatement(statement)) return CommentStatementSerializer.serialize(statement);
    if (isContentStatement(statement)) return ContentStatementSerializer.serialize(statement);
    if (isMustacheStatement(statement)) return MustacheStatementSerializer.serialize(statement);
    if (isPartialBlockStatement(statement))
      return PartialBlockStatementSerializer.serialize(statement, StatementSerializer.serializeAll);
    if (isPartialStatement(statement)) return PartialStatementSerializer.serialize(statement);

    throw new Error('Unable to serialize statement');
  };

  static serializeAll = (statements: AST.Statement[]): string =>
    concatenate(statements.map(StatementSerializer.serialize));
}
